import Grid from "@mui/material/Grid2";
import { Typography } from "@mui/material";
import ProcessLogsFilterCard from "./ProcessLogsFilter/ProcessLogsFilterCard";
import ProcessLogsTable from "./ProcessLogsTable";

const ProcessLogsBase = () => {
  const tableHeadings = {
    run_iD: "Run ID",
    brand_name: "Brand Name",
    pod_name: "Pod Name",
    start_date: "Start Date",
    end_date: "End Date",
    process_type: "Process Type",
    status: "Status",
  };
  const rows = [
    {
      run_iD: "2138",
      brand_name: "Spreadex Casino",
      pod_name: "Income access 5wfgj66hj",
      start_date: "19/03/2025",
      end_date: "20/03/2025",
      process_type: "Unifier",
      status: "Failed",
    },
    {
      run_iD: "2145",
      brand_name: "Betway",
      pod_name: "Affiliate Tracker 9kd78sdf",
      start_date: "18/03/2025",
      end_date: "19/03/2025",
      process_type: "Aggregator",
      status: "Success",
    },
    {
      run_iD: "2150",
      brand_name: "888 Casino",
      pod_name: "Revenue Monitor 3hds89s",
      start_date: "17/03/2025",
      end_date: "18/03/2025",
      process_type: "Validator",
      status: "Running",
    },
    {
      run_iD: "2162",
      brand_name: "Bet365",
      pod_name: "Traffic Analyzer qh4d8ad",
      start_date: "16/03/2025",
      end_date: "17/03/2025",
      process_type: "Cleaner",
      status: "Success",
    },
    {
      run_iD: "2171",
      brand_name: "PokerStars",
      pod_name: "Data Enrichment xhwe7s8",
      start_date: "15/03/2025",
      end_date: "16/03/2025",
      process_type: "ETL",
      status: "Success",
    },
    {
      run_iD: "2183",
      brand_name: "William Hill",
      pod_name: "Ad Tracker 9s8d78s",
      start_date: "14/03/2025",
      end_date: "15/03/2025",
      process_type: "Unifier",
      status: "Failed",
    },
    {
      run_iD: "2190",
      brand_name: "Ladbrokes",
      pod_name: "Market Intelligence asd97sd",
      start_date: "13/03/2025",
      end_date: "14/03/2025",
      process_type: "Aggregator",
      status: "Running",
    },
    {
      run_iD: "2201",
      brand_name: "DraftKings",
      pod_name: "User Behavior Analysis 8d7f6d",
      start_date: "12/03/2025",
      end_date: "13/03/2025",
      process_type: "Validator",
      status: "Running",
    },
    {
      run_iD: "2210",
      brand_name: "FanDuel",
      pod_name: "ROI Calculator 2s3d5fd",
      start_date: "11/03/2025",
      end_date: "12/03/2025",
      process_type: "Cleaner",
      status: "Success",
    },
    {
      run_iD: "2225",
      brand_name: "Caesars Casino",
      pod_name: "Campaign Tracker 7f8d9s0",
      start_date: "10/03/2025",
      end_date: "11/03/2025",
      process_type: "ETL",
      status: "Failed",
    },
  ];

  return (
    <>
      <Grid container alignItems="center" sx={{ mb: 2 }}>
        <Grid size={12} mb={2}>
          <Typography variant="h3" sx={{ fontSize: "24px" }}>
            Process logs
          </Typography>
          <Typography variant="body2" sx={{ fontSize: "14px" }}>
            Get, edit and update brad data in Unifier, Fetcher and Business
            Advisor.
          </Typography>
        </Grid>
        <ProcessLogsFilterCard />
      </Grid>
      <ProcessLogsTable tableHeadings={tableHeadings} rows={rows} />
    </>
  );
};

export default ProcessLogsBase;
